import React, { useCallback, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useNavigate, useOutletContext } from 'react-router-dom';
//api
import { createEditorial } from 'api/products';
//components
import Title from 'components/backoffice/texts/title';
import EditorialForm from 'components/backoffice/forms/editorialForm';


const editorial = {
  nombre_fiscal: '',
  nombre_comercial: '',
  cif: '',
  direccion: '',
  telefono: '',
  email: '',
  url: '-',
  pais: undefined,
  localidad: undefined,
}

const EditorialCreate = () => {
  const { t } = useTranslation(['backoffice']);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { setTitle } = useOutletContext()

  useEffect(() => {
    setTitle(t('createeditorial'))
    return () => {
      setTitle('');
    }
  }, [setTitle])

  const onSubmit = useCallback(async (values) => {
    setLoading(true)
    const data = {
      nombre_fiscal: values.nombre_fiscal,
      nombre_comercial: values.nombre_comercial,
      cif: values.cif,
      direccion: values.direccion,
      telefono: values.telefono,
      email: values.email,
      pais: values.pais?.id,
      localidad: values.localidad?.id,
      url: values.url,
    };

    try {
      const { status } = await createEditorial(data);
      if (status === 201 || status === 200) {
        toast.success(t('creadocorrectamente'));
        navigate('/intranet/editorials', { replace: true });
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false)
  }, []);


  return (
    <div className="mt-2">
      <Title text={t('createeditorial')} />
      <EditorialForm
        loading={loading}
        isEditing={false}
        onSubmitForm={onSubmit}
        defaultValues={editorial}
      />
    </div>
  );
};

export default EditorialCreate;
